import { createSlice } from "@reduxjs/toolkit";
import {
  fetchAllQuestions,
  fetchAllTests,
  fetchConsultationTableData,
  getAllTestsName,
} from "../features/trainerAsync";

const initialState = {
  NewQuestionmodalOpened: false,
  AllQuestionconfirmDirty: false,
  QuestionsearchText: "",
  loading: false,
  error:null,
  questionTableData: [],
  selectedSubjects: [],
  QuestionFormData: {},
  fifthoptioAddButtonVisible: true,
  TestTableLoading: false,
  TestTableData: [],
  ConsultationTabelData: [],
  AllTests: [],
  AllTestsName: [],
  TestsearchText: "",
  TestDetailsmodalOpened: false,
  AllTestLoader: false,
  DataActiveTestDetails: {
    testDetailsId: null,
    testquestions: [],
  },
};

const questionSlice = createSlice({
  name: "trainer",
  initialState,
  reducers: {
    changeQuestionModalState(state, action) {
      state.NewQuestionmodalOpened = action.payload;
    },
    changeQuestionFormConfirmDirty(state, action) {
      state.AllQuestionconfirmDirty = action.payload;
    },
    changeQuestionSearchText(state, action) {
      state.QuestionsearchText = action.payload;
    },
    changeQuestionTableLoadingStatus(state, action) {
      state.QuestionTableLoading = action.payload.payload1 ?? action.payload[0];
      state.QuestionTableData = action.payload.payload2 ?? action.payload[1];
    },
    addFifthOption(state) {
      if (!state.QuestionFormData.options) {
        state.QuestionFormData.options = [];
      }
      state.QuestionFormData.options.push({
        image: null,
        body: null,
        isAnswer: false,
      });
      state.fifthoptioAddButtonVisible = false;
    },
    changeSelectedSubject(state, action) {
      state.selectedSubjects = action.payload;
    },
    changeQuestionFormData(state, action) {
      state.QuestionFormData = action.payload;
    },
    changeTestDetailsModalState(state, action) {
      const { payload1, payload2, payload3 } = action.payload;
      state.TestDetailsmodalOpened = payload1;
      state.DataActiveTestDetails.testDetailsId = payload2;
      state.DataActiveTestDetails.testquestions = payload3;
    },
    changeTestSearchText(state, action) {
      state.TestsearchText = action.payload;
    },
    changeTestTableLoadingStatus(state, action) {
      state.TestTableLoading = action.payload.payload1 ?? action.payload[0];
      state.TestTableData = action.payload.payload2 ?? action.payload[1];
    },
    changeConsultationTableLoadingStatus(state, action) {
      state.TestTableLoading = action.payload.payload1 ?? action.payload[0];
      state.ConsultationTabelData =
        action.payload.payload2 ?? action.payload[1];
    },
    changeTestLoadingStatus(state, action) {
      state.AllTestLoader = action.payload.payload1 ?? action.payload[0];
      state.AllTests = action.payload.payload2 ?? action.payload[1];
    },
    changeCurrentActiveTestQuestion(state, action) {
      state.DataActiveTestDetails.testquestions = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllQuestions.pending, (state) => {
        state.loading = true;
        state.questionTableData = [];
      })
      .addCase(fetchAllQuestions.fulfilled, (state, action) => {
        state.loading = false;
        state.questionTableData = action.payload;
      })
      .addCase(fetchAllQuestions.rejected, (state) => {
        state.loading = false;
        state.questionTableData = [];
      })
      //All test
      .addCase(fetchAllTests.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.TestTableData = [];
      })
      .addCase(fetchAllTests.fulfilled, (state, action) => {
        state.loading = false;
        state.TestTableData = action.payload;
      })
      .addCase(fetchAllTests.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.TestTableData = [];
      })
    // AllTestName
      .addCase(getAllTestsName.pending, (state) => {
        state.loading = true;
        state.AllTestsName = [];
        state.error = null;
      })
      .addCase(getAllTestsName.fulfilled, (state, action) => {
        state.loading = false;
        state.AllTestsName = action.payload;
      })
      .addCase(getAllTestsName.rejected, (state, action) => {
        state.loading = false;
        state.AllTestsName = [];
        state.error = action.payload;
      })
      // // ConsultationTableData
      .addCase(fetchConsultationTableData.pending, (state) => {
        state.loading = true;
        state.ConsultationTabelData = [];
        state.error = null;
      })
      .addCase(fetchConsultationTableData.fulfilled, (state, action) => {
        state.loading = false;
        state.ConsultationTabelData = action.payload;
      })
      .addCase(fetchConsultationTableData.rejected, (state, action) => {
        state.loading = false;
        state.ConsultationTabelData = [];
        state.error = action.payload;
      });
  },
});

export const {
  changeQuestionModalState,
  changeQuestionFormConfirmDirty,
  changeQuestionSearchText,
  changeQuestionTableLoadingStatus,
  addFifthOption,
  changeSelectedSubject,
  changeQuestionFormData,
  changeTestDetailsModalState,
  changeTestSearchText,
  changeTestTableLoadingStatus,
  changeConsultationTableLoadingStatus,
  changeTestLoadingStatus,
  changeCurrentActiveTestQuestion,
} = questionSlice.actions;

export default questionSlice.reducer;
